var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person"},[_c('div',{},[_c('personTable',{attrs:{"isRecommendations":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }